import React from 'react';
import './logo.css';

const Logo = () => {
  return (
    <div className="dashboard-header-logo">
      <i className="dashboard-header-logo-image" />
      <div className="dashboard-header-logo-title">SOW Evangelism</div>
    </div>
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/dashboard/logo.js